import { Button } from "@/components/ui/baseUi/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/baseUi/dropdown-menu"
import { cn } from "@/modules/lib/utils"
import { EllipsisVertical } from "lucide-react"

export type EllipsisMenuProps = {
  className?: string
  buttonClassName?: string
  contentClassName?: string
  children?: React.ReactNode
  propsContent?: React.ComponentProps<typeof DropdownMenuContent>
} & React.ComponentProps<"button">

export function EllipsisMenu({
  buttonClassName,
  className,
  contentClassName,
  children,
  propsContent,
  ...props
}: EllipsisMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button variant="outline" size="iconMd" className={cn(className)} data-testid="ellipsis-menu" {...props}>
            <EllipsisVertical className={cn("size-4", buttonClassName)} />
          </Button>
        }
      />
      <DropdownMenuContent className={cn("mr-4 w-fit", contentClassName)} {...propsContent}>
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
